// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Version_wrapper__FTLru"};